<template>
  <div>
        <el-empty description="No Data" v-if="$store.getters.getCustomerPaymentList.length === 0 && !readonly">
            <el-button  v-if="!$store.getters.getLoadingState && $store.getters.getAccessRights.can_add" @click="createNew" type="primary" size="small">Record New Receipt</el-button>
        </el-empty>

        <div v-else>
        <el-table
            @header-click="headerClick"        
            :summary-method="getSummaries"
            :show-summary="popup"
            :data="$store.getters.getCustomerPaymentList"
            style="width: 100%">
          
          <el-table-column 
            prop="t1.payment_date"
            sortable
            label="Date">
              <template slot-scope="scope">
                  <span class="rowFontSize">
                      {{scope.row.payment_date_changed_time}}
                  </span>
              </template>
          </el-table-column>
          <el-table-column 
            prop="t2.locality_name"
            sortable
            label="Location">
            <template slot-scope="scope">
                  <span class="rowFontSize">
                      {{scope.row.store_name}}
                  </span>
              </template>
          </el-table-column>
          <el-table-column 
            v-if="!popup"
            prop="t4.customer_name"
            sortable
            label="Customer">
            <template slot-scope="scope">
                  <span class="rowFontSize">
                      {{scope.row.changed_customer_name}}
                  </span>
              </template>
          </el-table-column>
          <el-table-column 
            prop="t6.sale_number"
            sortable
            label="Sale#">
            <template slot-scope="scope">
                  <span class="rowFontSize">
                      {{scope.row.sale_number}}
                  </span>
              </template>
          </el-table-column>
          <el-table-column 
            prop="t1.paid_amount"
            sortable
            label="Paid Amount" align="center">
              <template slot-scope="scope">
                <span class="rowFontSize" :style="'color: '+(parseFloat(scope.row.paid_amount)<0 ? 'red' : '')+';'">
                  {{(scope.row.paid_amount !== 0) ? formatCurrency(parseFloat(scope.row.paid_amount)) : ''}}                
                </span>                
              </template>
          </el-table-column>
          <el-table-column 
            prop="t1.redeemed_amount"
            sortable
            label="Settled" align="center">
              <template slot-scope="scope">
                <span style="color: red;" class="rowFontSize">
                  {{scope.row.redeemed_amount > 0 ? formatCurrency(parseFloat(scope.row.redeemed_amount)) : ''}}                
                </span>
              </template>
          </el-table-column>
          <el-table-column 
            prop="t1.adjustment"
            sortable
            label="Adjustment" align="center">
              <template slot-scope="scope">
                <span class="rowFontSize" :style="'color: red;'">
                  {{(scope.row.adjustment !== 0) ? formatCurrency(parseFloat(scope.row.adjustment)) : ''}}                
                </span>                
              </template>
          </el-table-column>
          
          <el-table-column 
            prop="t5.mode_name"
            sortable
            label="Paid Through">
              <template slot-scope="scope">
                <span class="rowFontSize">
                  {{scope.row.redeemed_amount>0 ? 'On-Account' : scope.row.mode_name}}
                </span>
              </template>
          </el-table-column>
          <el-table-column
                v-if="!readonly"
                fixed="right"
                label=""
                width="120">
                <template slot-scope="scope">
                    <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        <el-tooltip class="item" effect="dark" :content="'Email Receipt'">
                          <a @click="printRcpt(scope.row.id, 'email')" style="cursor: pointer; margin-right: 10px;">
                            <i :class="$store.getters.getLoadingState ? 'el-icon-loading' : 'el-icon-message'"></i>
                          </a>
                        </el-tooltip>
                        
                        <el-tooltip class="item" effect="dark" :content="'Print Receipt'">
                          <a @click="printRcpt(scope.row.id, 'print')" style="cursor: pointer; margin-right: 10px;">
                            <i :class="$store.getters.getLoadingState ? 'el-icon-loading' : 'el-icon-printer'"></i>
                          </a>
                        </el-tooltip>
                        
                        <el-tooltip class="item" effect="dark" :content="$store.getters.getAccessRights.can_edit ? 'Edit' : 'View'">
                          <a v-if="scope.row.redeemed_amount === 0" @click="openForm({ id: scope.row.id, copy: false, navigate: true })" style="cursor: pointer;">
                            <i :class="$store.getters.getLoadingState ? 'el-icon-loading' : $store.getters.getAccessRights.can_edit ? 'el-icon-edit' : 'el-icon-view'"></i>
                          </a>
                        </el-tooltip>
                        
                        <el-tooltip class="item" effect="dark" content="Delete">
                          <el-popconfirm
                              @confirm="deleteData(scope.row)"
                              title="Are you sure to delete this?"
                              >
                                <a v-if="$store.getters.getAccessRights.can_delete" slot="reference" style="cursor: pointer; margin-left: 10px; color: red;">
                                  <i class="el-icon-delete"></i>
                                </a>
                              
                          </el-popconfirm>
                        </el-tooltip>
                        
                    </div>                                        
                </template>
            </el-table-column>
        </el-table>
        <br>
        <GridPagination :dataProps="$store.state.customerPayment.nav" @navigateButton="navigateButton"/>
        </div>
        <br>
        <PrintWindow 
          :title="getPrintTitle"
          v-if="isPrintWindowVisible"
          :src="getPrintSrc"
          :dialogVisible="isPrintWindowVisible" 
          @closePrintWindow="showPrintWindow = false" />

    
  </div>
</template>

<script>
export default {
    props: ['popup', 'source', 'source_id', 'readonly'],
    data() {
      return {
        paidAmount: 0,
        redeemed_amount: 0,
        showPrintWindow: false,
        printSrc: '',
        printTitle: ''
      }
    },
    computed: {
        getPrintTitle() {
            return this.printTitle
        },
        getPrintSrc() {
            return this.printSrc
        },
        isPrintWindowVisible() {
            return this.showPrintWindow
        }
    },
    methods: {
        navigateButton() {
          this.$store.dispatch('fetchCustomerPaymentList', {store_list: this.$store.getters.getAccessibleStoreList, nav: this.$store.state.customerPayment.nav})
        },
        headerClick($column) {
            this.$store.state.customerPayment.nav.sort_column_name = $column.property
            let sortDirection = this.$store.state.customerPayment.nav.sort_direction
            if(sortDirection === 0) {
              this.$store.state.customerPayment.nav.sort_direction = 1
            } else {
              this.$store.state.customerPayment.nav.sort_direction = 0
            }
            
            this.navigateButton()
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = 'Total';
                    return;
                } else if (index === 1) {
                    sums[index] = '';
                    return;
                } else if (index === 2) {
                    sums[index] = '';
                    return;
                } else if (index === 3) {
                    this.paidAmount = data.reduce((count, element1) => {return ( !isNaN(parseFloat(element1.paid_amount)) ? count + parseFloat(element1.paid_amount) : count + 0);}, 0);
                    sums[index] = this.formatCurrency(this.paidAmount)
                    return;
                } else if (index === 4) {
                    this.redeemed_amount = data.reduce((count, element1) => {return !isNaN(parseFloat(element1.redeemed_amount)) ? count + parseFloat(element1.redeemed_amount) : count + 0;}, 0);
                    sums[index] = this.formatCurrency(this.redeemed_amount)
                    return;
                } else if (index === 5) {
                    sums[index] = '';
                    return
                } else if (index === 6) {
                    sums[index] = '';
                    return
                }
            })
            return sums;
        },
        openForm(payload) {
          if(this.popup) {
              if(this.checkIfModuleAccessAvailable('/customerpayment', 'can_edit')) {
                this.$emit('openPaymentForm')
                payload.navigate = false
                this.$store.dispatch('fetchCustomerPaymentData', payload)
              }              
          } else {
              this.$store.dispatch('fetchCustomerPaymentData', payload)
          }
        },
        async deleteData(rowScope) {
          if(this.popup) {
              if(this.checkIfModuleAccessAvailable('/customerpayment', 'can_delete')) {
                await this.$store.dispatch('deleteCustomerPaymentData', 
                  {
                    id: rowScope.id, 
                    customer_id: rowScope.customer_id,
                    sale_id: rowScope.sale_id,
                    store_list: this.$store.getters.getAccessibleStoreList,
                    list: {store_list: this.$store.getters.getAccessibleStoreList, nav: this.$store.state.customerPayment.nav}
                  })
                setTimeout(() => {
                  this.$emit('closed')
                }, 1000);
              }              
          } else {
            if(this.checkIfModuleAccessAvailable('/customerpayment', 'can_delete')) {
              this.$store.dispatch('deleteCustomerPaymentData', 
                {
                  id: rowScope.id, 
                  customer_id: rowScope.customer_id,
                  sale_id: rowScope.sale_id,
                  store_list: this.$store.getters.getAccessibleStoreList,
                  list: {store_list: this.$store.getters.getAccessibleStoreList, nav: this.$store.state.customerPayment.nav}
                })
            }
          }
          
        },
        printRcpt(paymentId, command) {

            if(command == "print") {
                this.printTitle = 'Paper Size: A5'
                this.printSrc = this.master_url+'target=customerPayment&subpage=print&customer_payment_id='+paymentId+'&access_token='+this.$store.getters.getAccessToken
                this.showPrintWindow = true
            } else if(command == "email") {
                this.$confirm('Are you sure to proceed?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.printTitle = 'Processing Mail'
                    this.printSrc = this.master_url+'target=customerPayment&subpage=email&customer_payment_id='+paymentId+'&access_token='+this.$store.getters.getAccessToken
                    this.showPrintWindow = true
                }).catch(() => {
                            
                });
            }
        },
        createNew() {
          this.$store.commit('resetCustomerPaymentData')
          if(this.popup) {
              if(this.checkIfModuleAccessAvailable('/customerpayment', 'can_add')) {
                this.$emit('openPaymentForm')
              }
          } else {
            this.$router.push(this.$router.currentRoute.fullPath+'/form/')
          }
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/CustomerPayment/List.vue